<template>
  <div class="min-h-screen flex flex-col">
    <AppHeader />
    <main class="flex-1">
      <RouterView />
    </main>
    <footer class="max-w-[100rem] px-4 py-5 sm:px-6 lg:px-8 mx-auto">
      <div class="text-center">
        <p class="text-gray-500">
          Copyright &copy; {{ new Date().getFullYear() }} VDE Verband der Elektrotechnik Elektronik Informationstechnik e.V.
        </p>
      </div>
    </footer>
    <NotificationToaster />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import AppHeader from "@/shared/components/AppHeader.vue";
import { NotificationToaster } from "@/components/ui/toast";
import { useAuthStore } from "@/features/identity/composables/useAuthStore";

const { loadAuth } = useAuthStore();

onMounted(() => {
  loadAuth();
});
</script>
